export default {
  headerHeight: 75,
  subHeaderHeight: 63,
  footerHeight: 20,
  graphLegendHeight: '150px',
  graphHeaderHeight: '75px',
  graphDropdownHeight: '27px',
};
